export default "__VITE_ASSET__E267eKzf__"